import { useTranslation } from "react-i18next";
import TrashIcon from "@/assets/icons/trash.svg?react";
import { cn } from "@/lib/utils";
import { useFormContext } from "react-hook-form";
import { ControlledInputV3 } from "@/components/ui/customs/controlled-input-v3";
import { ControlledSelectV2 } from "@/components/ui/customs/controlled-select-v2";
import { volumesOptions } from "@/constants/options/volumes.option";
import { StyledSelectSingleValueInt } from "@/components/styled/StyledSelectSingleValueInt";
import { QuotationUpdateBoFormData } from "./expeditionsUpdateBoForm";
import StyledInput from "@/components/styled/StyledInput";
import { useWineColorOptions } from "@/hooks/useEnumOptions";

export const WineListElem = ({
  index,
  remove,
  error,
  hasScannedInvoice,
}: {
  index: number;
  remove: () => void;
  error: boolean;
  hasScannedInvoice?: boolean;
}) => {
  const { t } = useTranslation("boExpeditionForm");
  const wineColorOptions = useWineColorOptions();
  const methods = useFormContext<QuotationUpdateBoFormData>();

  if (hasScannedInvoice) {
    return (
      <div
        className={`flex items-center justify-center gap-4 rounded-lg border bg-gray-50 p-4 lg:justify-between ${error ? "border-red-500" : ""}`}
      >
        <div className="flex w-full flex-row justify-between gap-4">
          <div />
          <div />
          <div className="flex flex-1 flex-wrap gap-4">
            <StyledSelectSingleValueInt
              title={t("productElem.volumeLabel")}
              setValue={(e: any) => {
                methods.setValue(`deliveryContent.${index}.volume`, e);
              }}
              options={volumesOptions.map((volume) => ({
                label: volume.label,
                value: volume.value,
              }))}
              control={methods.control}
              name={`deliveryContent.${index}.volume`}
              className="flex-1"
              isSearchable={false}
            />
            <StyledInput
              title={t("productElem.quantityLabel")}
              control={methods.control}
              name={`deliveryContent.${index}.quantity`}
              type="number"
              className="flex-1"
            />
            <ControlledInputV3
              label={t("productElem.unitPriceLabel")}
              control={methods.control}
              name={`deliveryContent.${index}.price`}
              inputType="float"
              maxDecimal={4}
              placeholder={t("productElem.unitPricePlaceholder")}
              className="flex-1"
            />
          </div>
          <div />
          <div />
        </div>
        <div className="flex w-fit gap-4">
          <button
            type="button"
            onClick={remove}
            className="rounded-full px-2 py-2 hover:bg-gray-200"
          >
            <TrashIcon color="#DC2626" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-4 rounded-lg border bg-gray-50 p-2 sm:p-4 lg:justify-between ${error ? "border-red-500" : ""}`}
    >
      <div className="flex flex-1 flex-col gap-4">
        <div className="flex flex-wrap items-start gap-2">
          <ControlledInputV3
            label={t("productElem.wineNameLabel")}
            control={methods.control}
            name={`deliveryContent.${index}.wineName`}
            className="max-w-[200px] min-w-[130px]"
            placeholder={t("productElem.wineNamePlaceholder")}
          />
          <ControlledInputV3
            label={t("productElem.yearLabel")}
            control={methods.control}
            name={`deliveryContent.${index}.year`}
            type="number"
            className="w-[100px]"
            placeholder={t("productElem.yearPlaceholder")}
            disableDecimal
          />
          <ControlledInputV3
            label={t("productElem.alcoholPercentLabel")}
            control={methods.control}
            inputType="float"
            maxDecimal={2}
            name={`deliveryContent.${index}.alcoholPercent`}
            className="w-[70px]"
            placeholder={t("productElem.alcoholPercentPlaceholder")}
          />
          <StyledSelectSingleValueInt
            title={t("productElem.volumeLabel")}
            setValue={(e: any) => {
              methods.setValue(`deliveryContent.${index}.volume`, e);
            }}
            options={volumesOptions.map((volume) => ({
              label: volume.label,
              value: volume.value,
            }))}
            control={methods.control}
            name={`deliveryContent.${index}.volume`}
            className="w-[120px]"
            isSearchable={false}
            placeholder={t("productElem.volumePlaceholder")}
          />
          <ControlledSelectV2
            options={wineColorOptions}
            label={t("productElem.colorLabel")}
            placeholder=""
            control={methods.control}
            name={`deliveryContent.${index}.color`}
            contentClassName="w-[67px]"
          />
          <StyledInput
            title={t("productElem.quantityLabel")}
            control={methods.control}
            name={`deliveryContent.${index}.quantity`}
            type="number"
            className="w-[100px]"
          />
          <ControlledInputV3
            label={t("productElem.unitPriceLabel")}
            control={methods.control}
            name={`deliveryContent.${index}.price`}
            inputType="float"
            maxDecimal={4}
            className="w-[100px]"
            placeholder={t("productElem.unitPricePlaceholder")}
          />
        </div>
      </div>
      <div className={cn("hidden w-fit gap-2 lg:flex")}>
        <button type="button" onClick={remove} className="rounded-full px-1 py-1 hover:bg-gray-200">
          <TrashIcon color="#DC2626" />
        </button>
      </div>
    </div>
  );
};
